import { IStyleSettingValueParams, StyleSettingValue } from './StyleSettings.interfaces';

const getStyleSettingValue = ({ isChecked, type, value }: IStyleSettingValueParams): StyleSettingValue => {
  if (type === 'checkbox') {
    return isChecked;
  }

  if (type === 'number') {
    const numericValue = Number(value);

    return Number.isNaN(numericValue) ? 0 : numericValue;
  }

  return value;
};

export { getStyleSettingValue };
